export * from "./new-password-card";
export * from "./new-password-card.types";
